module.exports = __webpack_public_path__ + "static/images/monet/menu_down_active.svg";